/*! menu-badges
    Turns "[LABEL]" at the end of a menu item title into a badge above the link.

    The label is authored in Shopify admin under Content > Menus, so badges can be
    added or removed without touching the theme. Covers the desktop dropdowns and
    the mobile drawer.
*/

(function () {
  var SELECTOR = '.header .dropdown__nav a, .drawer__menu a.drawer__menu-item';
  var PATTERN = /\s*\[([^\]]{1,24})\]\s*$/;

  function modifier(label) {
    return label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(SELECTOR).forEach(function (link) {
      if (link.dataset.menuBadge === 'done') return;
      link.dataset.menuBadge = 'done';

      /* Only plain-text links: rewriting textContent would drop child markup */
      if (link.children.length > 0) return;

      var match = link.textContent.match(PATTERN);
      if (!match) return;

      var label = match[1].trim();
      if (!label) return;

      link.textContent = link.textContent.replace(PATTERN, '');

      var badge = document.createElement('span');
      badge.className = 'submenu-badge submenu-badge--' + modifier(label);
      badge.textContent = label;

      if (link.classList.contains('drawer__menu-item')) {
        /* Mobile: inside the link so it sits inline beside the label and the
           entry stays one line tall. */
        link.appendChild(badge);
      } else {
        /* Desktop: before the link, not inside it, so the link's accessible name
           stays clean and the theme's underline animation is left alone. */
        link.parentElement.insertBefore(badge, link);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      apply();
    });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', function () {
    apply();
  });
})();
